import React, { Component } from 'react';
import SecureLayout from '../../../templates/secure';
import {NavLink} from 'react-router-dom';
import _ from 'lodash';

class LinesAdd extends Component{
	render(){
		const {lines} =this.props;
		let lc = _.find(lines.permissions, (o) => {return o==='Create'});
		return (
			lc ?
				<p>
					<NavLink to={`/proigualdad/lineas/crear`} className="button is-small is-inm-purple">{'Agregar linea'}</NavLink>
				</p>:''
		)
	}
}

export default SecureLayout(LinesAdd);


// WEBPACK FOOTER //
// ./src/elements/lines/widget/lines_add.jsx